import Quickshop from './Quickshop';

export default class ProductListItem {
  constructor({ el }) {
    this.el = el;
    this.el
      .querySelector('.product-list-item-thumbnail')
      .addEventListener('click', event => this.redirectToProduct(event));
    this.productHover = document.querySelector('[data-product-hover]').dataset.productHover;
    this.quickshopTrigger = this.el.querySelector('.quick-shop-modal-trigger');

    if (this.productHover === 'quick-shop' && this.quickshopTrigger !== null) {
      this.quickshop = new Quickshop();
      this.quickshopTrigger.addEventListener('click', event => this.openQuickShop(event));
      this.quickshopTrigger.addEventListener('mouseover', event => this.preloadQuickshop(event));
    }
  }

  remove() {
    if (this.quickshop) {
      this.quickshop.unload();
      this.quickshopTrigger.removeEventListener('click', event => this.openQuickShop(event));
      this.quickshopTrigger.removeEventListener('mouseover', event => this.preloadQuickshop(event));
    }
    this.el
      .querySelector('.product-list-item-thumbnail')
      .removeEventListener('click', event => this.redirectToProduct(event));
  }

  redirectToProduct({ target }) {
    const url = !target.classList.contains('quick-shop-modal-trigger') ? target.dataset.url : null;

    if (url) {
      window.location = url;
    }
  }

  openQuickShop(e) {
    const productUrl = e.currentTarget.getAttribute('data-product-url');
    const productSha256 = e.currentTarget.getAttribute('data-product-sha256');
    return this.quickshop.open(productUrl, productSha256);
  }

  preloadQuickshop(e) {
    const productUrl = e.currentTarget.getAttribute('data-product-url');
    const productSha256 = e.currentTarget.getAttribute('data-product-sha256');
    return this.quickshop.load(productUrl, productSha256);
  }
}
